import _ from "lodash";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";
import Courses from "Courses";
import LearningCourse from "LearningCourse";
import StudentGoals from "StudentGoals";
import SnP_v2 from "Administrator/routes/SnP_v2";
import SnP from "Administrator/routes/SnP";
import ProfileV2 from "Platform/routes/ProfileV2";
import BehaviourManagement from "BehaviourManagement";
import Incident from "Incident";
import AdminEducatorCenterV2 from "Administrator/routes/AdminEducatorCenterV2";
import TeacherProfile from "TeacherProfile";
import ToddleAnalytics from "Teacher/routes/ToddleAnalytics";
import LTIWidget from "Teacher/routes/LTIWidget";
import PortfolioReview from "Teacher/routes/PortfolioReview";
import MessagingRoutes from "Platform/routes/MessagingV2";
import AttendanceDashboard from "Administrator/routes/AttendanceDashboard";
import Homeroom from "Homeroom";
import TeacherTimeTable from "Teacher/routes/TeacherTimeTable";
import ClassStreamManager from "Teacher/routes/ClassStreamManager";
import CurriculumInsights from "CurriculumInsights";
import CurriculumMaps from "CurriculumMaps";
import StudentPlans from "StudentPlans";
import NotificationSettings from "Teacher/routes/NotificationSettings";
import SchoolLibrary from "Teacher/routes/SchoolLibrary";
import AdminGradeBook from "Administrator/routes/AdminGradebook";
import { CircularRoutes } from "Administrator/routes/Circulars";
import TimetableManagerV2 from "Administrator/routes/TimetableManagerV2";
import ProgressReportSets from "Teacher/routes/ProgressReportSets";
import ProductUpdatesV2 from "ProductUpdatesV2";
import SymLinks from "Platform/routes/SymLinks";

export default store => {
  return {
    path: "my-home",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "homepage" */ "./components"),
          import(
            /* webpackChunkName: "homepage" */ "TimetablePlanner/modules/TimetablePlannerModule"
          ),
          import(
            /* webpackChunkName: "portfolioreview" */ "Teacher/routes/PortfolioReview/modules/PortfolioReviewModule"
          ),
        ]).then(([importedModule0, importedModule1, importedModule2]) => {
          const component = importedModule0.default;
          const timetablePlannerModule = importedModule1;
          const portfolioReviewModule = importedModule2;
          injectReducer(store, {
            key: timetablePlannerModule.NAME,
            reducer: timetablePlannerModule.default,
          });
          injectReducer(store, {
            key: portfolioReviewModule.NAME,
            reducer: portfolioReviewModule.default,
          });
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [
      SymLinks(store),
      Courses(store),
      LearningCourse(store),
      StudentGoals(store),
      SnP_v2(store),
      SnP(store),
      ProfileV2(store),
      AdminEducatorCenterV2(store),
      BehaviourManagement(store),
      Incident(store),
      TeacherProfile(store),
      ToddleAnalytics(store),
      LTIWidget(store),
      ..._.map(MessagingRoutes, comp => comp(store)),
      AttendanceDashboard(store),
      Homeroom(store),
      TeacherTimeTable(store),
      ClassStreamManager(store),
      PortfolioReview(store),
      CurriculumInsights(store),
      CurriculumMaps(store),
      StudentPlans(store),
      NotificationSettings(store),
      AdminGradeBook(store),
      ..._.map(CircularRoutes, route => route(store)),
      SchoolLibrary(store),
      TimetableManagerV2(store),
      ProgressReportSets(store),
      ProductUpdatesV2(store),
    ],
  };
};
